export default class Partner {
  constructor(type, stratum, pairWith) {
    this.type = type;
    this.stratum = stratum;
    this.pairWith = pairWith;
  }
}
